import { render } from "./RadioButtonGroup.vue?vue&type=template&id=55bef0b9"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=js"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=js"
script.render = render

export default script